import React from 'react';

const TrackIcon = () => {
  return (
    <svg viewBox="0 0 173.26 126.24" preserveAspectRatio="xMidYMin">
      <path d="M33.28 22.49H140a3 3 0 0 1 3 3v7.15H30.28v-7.15a3 3 0 0 1 3-3z" fill="#f47046" stroke="#a9aeb7" strokeMiterlimit="10"/>
      <path fill="#fff" stroke="#a9aeb7" strokeMiterlimit="10" d="M30.28 32.14h112.71v71.61H30.28z"/>
      <path fill="#e5e3e1" d="M30.85 32.64h18.59v70.57H30.85zM68.04 32.64h18.59v70.57H68.04zM105.23 32.64h18.59v70.57h-18.59z"/>
      <path fill="none" stroke="#a9aeb7" strokeLinecap="round" strokeMiterlimit="10" strokeDasharray="3,5" d="M32.85 45.52h110.14M32.85 59.43h110.14M32.85 73.34h110.14M32.85 87.25h110.14"/>
    </svg>
  );
}

export default TrackIcon;